import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  VISITOR_LIST,
  USER_LIST_DROPDOWN,
  VISIT_STATUS_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  CATEGORY_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, NOPAGINATE } from "../../constant/constant";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole
} from "../../components/Utils";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Modal } from "react-bootstrap";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import moment from "moment";
import ModalImage from "react-modal-image";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { Link } from "react-router-dom";
import Excel from "exceljs";
import { saveAs } from "file-saver";
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
import { usePermission } from "../../hooks/usePermission";

const VisitorsList = ({ visitType, visitTypeText }) => {
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filter, setFilter] = useState([]);

  const getPermission = (type, action = 'list') => {
    const types = {
      0: 'general',
      1: 'chief-guest',
      2: 'power-date',
      3: 'inductions'
    };
    return `visitors-${types[type]}-${action}`;
  };

  // const [modal, setModal] = useState(false);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [detailData, setDetailData] = useState({});
  const [loading, setLoading] = useState(true);
  const [detailsModal, setDetailModal] = useState(false);
  // const [error, setError] = useState("");
  // const [visitId, setVisitId] = useState();
  const [userOptions, setUserOptions] = useState({});
  // const [status, setStatus] = useState("");
  // const [statusSelected, setStatusSelected] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);
  const { hasPermission } = usePermission();
  // const [btnPdfDisabled, setBtnPdfDisabled] = useState(false);
  const [showClearBtn, setShowClearBtn] = useState(false);
  const refFlatpickr = useRef(null);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  //excel export start
  const columns = [{ header: 'Sl.No.', key: 'sno' }];
  if (hasRole([1])) { columns.push({ header: "Country", key: "country_name" }); }
  if (hasRole([1, 6])) { columns.push({ header: "State", key: "state_name" }); }
  if (hasRole([1, 6, 7])) { columns.push({ header: "Region", key: "region_name" }); }
  if (hasRole([1, 6, 7, 2])) { columns.push({ header: "Chapter", key: "chapter_name" }); }
  columns.push(
    { header: "Member", key: "user_name" },
    { header: "Visitor Type", key: "visitor_type_text" },
    { header: "Category", key: "category_name" },
    { header: "Visit Date", key: "visit_date" },
    { header: "Visitor Name", key: "visitor_name" },
    { header: "Visitor Company Name", key: "visitor_company_name" },
    { header: "Visitor Phone", key: "visitor_phone" },
    { header: "Visitor Email", key: "visitor_email" },
    // { header: "Visitor Address", key: "visitor_address" },
    { header: "Comments", key: "comments" },
    { header: "Visit Status", key: "visit_status_text" },
    { header: "Entry Date", key: "created_at" },
  );


  //excel title starts
  const { from_date, to_date } = filter;
  let workSheetName = `Vis`;
  if (from_date && to_date) {
    if (from_date === to_date) {
      workSheetName += ` (${moment(from_date).format("DD-MM-YYYY")})`; // single date
    } else {
      workSheetName += ` (${moment(from_date).format("DD-MM-YYYY")} to ${moment(to_date).format("DD-MM-YYYY")})`;
    }
  }
  //excel title end

  const workBookName = "Visitors List";

  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const fileName = workBookName;
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;
      // updated the font and fill for header row cells.
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'c4161c' },
        };
      });

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(VISITOR_LIST, {
          params: {
            paging_type: NOPAGINATE,
            visitor_type: visitType,
            isAdmin: 1,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.visitors;

            if (excelData.length < 1) {
              toast.error("No data found!.");
              return;
            }

            // loop through data and add each one to worksheet
            excelData.forEach((singleData) => {
              worksheet.addRow(singleData);
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, (row) => {
              // store each cell to currentCell
              const currentCell = row._cells;
              // loop through currentCell to apply border only for the non-empty cell of excel
              currentCell.forEach((singleCell) => {
                // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                const cellAddress = singleCell._address;
                console.log(singleCell);
                // apply border
                worksheet.getCell(cellAddress).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();
            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };
  //end

  // const visitorTypeOptions = [
  //   { value: 0, label: "Visitors" },
  //   { value: 1, label: "Chief Guest" },
  //   { value: 2, label: "Power Date" },
  //   { value: 3, label: "Inductions" },
  // ];

  const visitStatusOptions = [
    { value: 0, label: "Pending" },
    { value: 1, label: "Approved" },
    // { value: 2, label: "Rejected" }
  ];

  // const statusOptions = [
  //   { value: 0, label: "Pending" },
  //   { value: 1, label: "Approved" },
  //   // { value: 2, label: "Rejected" }
  // ];

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    refFlatpickr.current.flatpickr.setDate([]);
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  const updateVisitStatus = (visitId, status) => {
    axios
      .post(VISIT_STATUS_UPDATE + visitId, { status: status })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          setRefresh((prevRefresh) => !prevRefresh);
        }
      });
  };

  // const assignStatus = () => {
  //   if (status === "") {
  //     setError("Status is Required");
  //     return false;
  //   }
  //   axios
  //     .post(VISIT_STATUS_UPDATE + visitId, { status: status })
  //     .then((response) => {
  //       if (response.status === 200 && response.data.success) {
  //         setError("");
  //         setModal(false);
  //         toast.success(response.data.msg);
  //         setRefresh((prevRefresh) => !prevRefresh);
  //       }
  //     });
  // };

  useEffect(() => {
    setLoading(true);
    axios
      .get(VISITOR_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          visitor_type: visitType,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          const responseData = response.data.data;
          setData(responseData.visitors || []);
          setPaginator({
            prev: responseData.prev_page_url != null,
            next: responseData.next_page_url != null,
            total: responseData.total,
            current: responseData.current_page,
            last: responseData.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch user data
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          }
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch category data
        const categoryResponse = await axios.get(CATEGORY_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedCategoryOptions = categoryResponse.data.data;
        setCategoryOptions(fetchedCategoryOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, refresh, filter, perPage, visitType]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Visitors - {visitTypeText}</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Visitors {visitTypeText} List
                  </span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              {hasPermission(getPermission(visitType, 'list-export')) && (
                <div className="pt-btn">
                  <button
                    disabled={btnExcelDisabled}
                    type="button"
                    onClick={exportAsExcel}
                    className="btn rounded-pill btn-primary excel-btn ibutton"
                  >
                    <span className="tf-icons bx bxs-spreadsheet"></span>&nbsp;
                    Excel
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard">
          {/* <div className="card-header">
            <h5>Visitors List</h5>
          </div> */}

          <div className="container-fluid f_containter">
            <div className="row mb-4 gx-3">

              {hasRole([1]) &&
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6]) &&
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6, 7]) &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      ref={selectRegionRef}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              }

              {hasRole([1, 6, 7, 2]) &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) =>
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }
                    />
                  </div>
                </div>
              }

              {visitType == 3 &&
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="category_id">
                      Category
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="category_id"
                      isClearable
                      options={categoryOptions}
                      onChange={(selected) =>
                        setFilter({ ...filter, category_id: selected?.value })
                      }
                    />
                  </div>
                </div>
              }

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, user_id: selected?.value })
                    }
                  />
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="visitor_type">
                    Visitor Type
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="visitor_type"
                    isClearable
                    options={visitorTypeOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, visitor_type: selected?.value })
                    }
                  />
                </div>
              </div> */}
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="visit_status">
                    Visit Status
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="visit_status"
                    isClearable
                    options={visitStatusOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, visit_status: selected?.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="date_range">
                    Date Range
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Select Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th>Member</th>
                  {visitType == 3 &&
                    <th>Category</th>
                  }
                  {/* <th>Visitor Type</th> */}
                  <th>Visitor Name</th>
                  <th>Visitor Phone</th>
                  <th>Visit Status</th>
                  <th>Visit Date</th>
                  <th>Entry Time</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="14" />
                ) : data.length > 0 ? (
                  data.map((visitor, i) => (
                    <tr key={i}>
                      <td>{visitor?.sno}</td>
                      {hasRole([1]) && <td>{visitor?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{visitor?.state_name}</td>}
                      {hasRole([1, 6, 7]) && <td>{visitor?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && <td>{visitor?.chapter_name}</td>}
                      <td>
                        <span className="table_img pr-2">
                          <img src={visitor?.user_profile_image} alt="icon" />
                        </span>
                        {visitor?.user_name}
                      </td>
                      {visitType == 3 &&
                        <td>{visitor?.category_name}</td>
                      }
                      {/* <td>{visitor?.visitor_type_text}</td> */}
                      <td>{visitor?.visitor_name}</td>
                      <td>{visitor?.visitor_phone}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${i}`}
                          value="1"
                          disabled={!hasPermission(getPermission(visitType, 'edit'))}
                          checked={visitor?.visit_status === 1 ? true : false}
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            updateVisitStatus(visitor?.id, statusVal);
                          }}
                        />
                      </td>
                      {/* <td>{visitor?.visit_status_text}</td> */}
                      <td>{visitor?.visit_date}</td>
                      <td>{visitor?.created_at}</td>
                      <td style={{ textAlign: "center" }}>
                        {hasPermission(getPermission(visitType)) && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(visitor);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}

                        {/* <button
                            className="badge bg-label-success me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Change visit status"
                            data-bs-original-title="Change visit status"
                            onClick={() => {
                              setVisitId(visitor?.id);
                              setStatus(visitor?.visit_status);
                              setModal(true);
                              setStatusSelected({ value: visitor?.visit_status, label: visitor?.visit_status_text })
                            }}
                          >
                            <i className="bx bx-edit-alt"></i>
                          </button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="14" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
        </div>
      </div>

      <Modal
        show={detailsModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Visitor Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.created_at)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">User Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.user_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Visitor type</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.visitor_type_text)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Visitor Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.visitor_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Visitor Company Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.visitor_company_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Visitor Phone</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.visitor_phone)}
                  </span>
                </div>
              </div>

              {visitType == 3 &&
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label m-0">Category Name</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.category_name)}
                    </span>
                  </div>
                </div>
              }

              {visitType != 3 &&
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label m-0">Visitor Email</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.visitor_email)}
                    </span>
                  </div>
                </div>
              }

              {/* {visitType != 3 &&
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label m-0">Visitor Address</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.visitor_address)}
                    </span>
                  </div>
                </div>
              } */}

              {detailData.visitor_type === 2 && (
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label m-0">Image</label>

                    {detailData.image !== "" ? (
                      <span className="d-block font-weight-600">
                        <ModalImage
                          small={detailData.image}
                          large={detailData.image}
                          alt="visitor power date Image"
                          showRotate
                        />
                      </span>
                    ) : (
                      <span className="d-block font-weight-600">-</span>
                    )}
                  </div>
                </div>
              )}

              {visitType != 3 &&
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label m-0">Comment</label>
                    <span className="d-block font-weight-600">
                      {checkEmptyOrNull(detailData.comments)}
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* <Modal
        show={modal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h6 className="modal_title">Visit Status</h6>
          <div className="row">
            <div className="col-12 mb-3">

              <Select
                options={statusOptions}
                value={statusSelected}
                onChange={(selected) => { setStatus(selected?.value); setStatusSelected(selected); }}
              />
              <span className="text-danger">{error}</span>
            </div>
          </div>
          <div className="text-right">
            <button
              onClick={() => {
                assignStatus();
              }}
              className="btn btn-danger btn-md m-4 igreen_btn"
            >
              Update Status
            </button>
          </div>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default VisitorsList;
